import { create } from 'zustand';

type MakeAnnouncementModalStoreProps = {
	isOpen: boolean;
	hideManageLink?: boolean;
	onClose: () => void;
	onOpen: (options?: { hideManageLink?: boolean }) => void;
};

export const useMakeAnnouncementModalStore = create<MakeAnnouncementModalStoreProps>((set) => ({
	isOpen: false,
	hideManageLink: undefined,
	onClose: () => set({ isOpen: false, hideManageLink: undefined }),
	onOpen: (options?: unknown) => {
		// Defensively handle non-object values (e.g., click events passed by onClick handlers)
		const hideManageLink = options && typeof options === 'object' && 'hideManageLink' in options ? (options.hideManageLink as boolean) : undefined;
		set({ isOpen: true, hideManageLink });
	},
}));

export const useMakeAnnouncementModal = () => useMakeAnnouncementModalStore((state) => state);
